import { render, staticRenderFns } from "./SelectSemesters.vue?vue&type=template&id=37f30f56"
import script from "./SelectSemesters.vue?vue&type=script&lang=js"
export * from "./SelectSemesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports